import { formatSecondsToDuration } from "@jugl-web/utils/date-time/formatSecondsToDuration";
import { useIntervalRerender } from "@jugl-web/utils/hooks/useIntervalRerender";
import { differenceInSeconds } from "date-fns";
import { FC } from "react";

interface CurrentTimerTextProps {
  startDate: Date;
}

export const CurrentTimerText: FC<CurrentTimerTextProps> = ({ startDate }) => {
  useIntervalRerender(500);

  return (
    <>{formatSecondsToDuration(differenceInSeconds(new Date(), startDate))}</>
  );
};
